import { legacyPlugins } from "/builds/DEVV/russmedia-frontend-nuxt3/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}